import { h, JSX } from 'preact';

import {
    CalendarIcon,
    ClockIcon,
    GlobeIcon,
    LocationIcon,
    SecurityIcon,
    SubtitleIcon,
    SvgProps,
} from './Icons';

type EventDetailIconName = (
    | 'calendar'
    | 'location'
    | 'clock'
    | 'globe'
    | 'subtitle'
    | 'security'
);

export interface EventDetail {
    icon: EventDetailIconName;
    iconTitle: string;
    text: string;
}

export interface EventDetailsProps {
    publicInfo?: string;
    items: EventDetail[];
    tags?: string[];
}

const EventDetailIcon = (props: { name: EventDetailIconName, svgProps: SvgProps }): JSX.Element => {
    switch (props.name) {
        case 'calendar': return <CalendarIcon {...props.svgProps} />;
        case 'location': return <LocationIcon {...props.svgProps} />;
        case 'clock': return <ClockIcon {...props.svgProps} />;
        case 'globe': return <GlobeIcon {...props.svgProps} />;
        case 'subtitle': return <SubtitleIcon {...props.svgProps} />;
        case 'security': return <SecurityIcon {...props.svgProps} />;
    }
};

export const EventDetails = (props: EventDetailsProps): JSX.Element => (
    <div class='flex flex-col gap-2 mt-4'>
        {props.publicInfo && (
            <div class='text-kinola-orange'>
                {props.publicInfo}
            </div>
        )}
        {props.items.map((item) => (
            <div class='flex items-center gap-2'>
                <div title={item.iconTitle}>
                    <EventDetailIcon
                        name={item.icon}
                        svgProps={{ class: 'block' }}
                    />
                </div>
                <div>{item.text}</div>
            </div>
        ))}
        {props.tags && (
            <div class='flex gap-1'>
                {props.tags.map((tag) => (
                    <div class='inline-block py-1.5 px-2 rounded bg-[#e5f0f3] text-primary-900 text-sm'>{tag}</div>
                ))}
            </div>
        )}
    </div>
);
